import { ZodObject, ZodSchema, z } from 'zod'

export const ERROR_OBJECT_SCHEMA = z.object( {
  message : z.string(),
  path : z.array( z.string() ).optional(),
  params : z.any().optional()
} )

export const VALIDATOR_FUNCTION_SCHEMA = z
  .function()
  .args(
    // Field/Form value
    z.any()
  )
  .returns(
    z.union( [
      z.boolean(),
      z.string(),
      ERROR_OBJECT_SCHEMA,
      z.promise( z.union( [ z.boolean(), z.string(), ERROR_OBJECT_SCHEMA ] ) )
    ] ).optional()
  )
  .transform( val => z.any().superRefine( async ( value, ctx ) => {
    const p = val( value )
    const res = p instanceof Promise ? await p : p

    if ( res === true ) {
      return
    }

    if ( res === false ) {
      ctx.addIssue( {
        code : z.ZodIssueCode.custom,
      } )
    } else if ( typeof res === 'object' ) {
      ctx.addIssue( {
        ...res,
        code : z.ZodIssueCode.custom
      } )
    } else {
      ctx.addIssue( {
        code : z.ZodIssueCode.custom,
        message : res
      } )
    }
  } ) )

const VALIDATOR_ITEM_SCHEMA = z
  .union( [
    z.instanceof( ZodSchema ),
    VALIDATOR_FUNCTION_SCHEMA
  ] )

const RAW_OBJECT_VALIDATOR_SCHEMA = z.record(
  z.string(),
  z.union( [
    z.instanceof( ZodSchema ),
    VALIDATOR_FUNCTION_SCHEMA
  ] )
).transform( val => z.object( val ) )

const ALLOWABLE_OBJECT_SCHEMA_TYPES = z.union( [
  RAW_OBJECT_VALIDATOR_SCHEMA,
  z.instanceof( ZodSchema )
] )

export const OBJECT_VALIDATOR_SCHEMA = z.union( [
  z.array( ALLOWABLE_OBJECT_SCHEMA_TYPES ),
  ALLOWABLE_OBJECT_SCHEMA_TYPES
] )

export const VALIDATOR_SCHEMA = z.union( [
  z.array( VALIDATOR_ITEM_SCHEMA ),
  VALIDATOR_ITEM_SCHEMA
] )

const LABEL_DECORATOR_ITEM_SCHEMA = z.union( [
  z.string(),
  z.function().args( z.string() ).returns( z.any() )
] ).optional()

const LABEL_DECORATOR_SCHEMA = z.union( [
  LABEL_DECORATOR_ITEM_SCHEMA,
  z.array( LABEL_DECORATOR_ITEM_SCHEMA )
] )

export const FIELD_SCHEMA = z.object( {
  name : z.string(),
  valueValidator : VALIDATOR_SCHEMA.optional(),
  labelDecorator : LABEL_DECORATOR_SCHEMA
} ).strict()
export const FIELDS_SCHEMA = z.record( z.string(), FIELD_SCHEMA )
